export default __webpack_public_path__ + "assets/images/b405c259f362d729e1d257745f885ef4.svg";